'use strict';

var framerMotion = require('framer-motion');
var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Portal = require('../../Portal/src/Portal.js');
var Notifications_module = require('../styles/Notifications.module.less.js');
var Notification = require('./Notification.js');
var NotificationManager = require('./NotificationManager.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description Display a notification message globally
 *
 * @component
 * @example
 * ```jsx
 * <Notifications />
 * ```
 */
const Notifications = React__namespace.memo((props) => {
    const { className, ...restProps } = props;
    const cx = reactUtils.useStyles(Notifications_module.default);
    const [notifications, setNotifications] = React__namespace.useState([]);
    const handleStoreChange = React__namespace.useCallback((items) => {
        setNotifications(items);
    }, []);
    React__namespace.useEffect(() => {
        NotificationManager.default.addChangeListener(handleStoreChange);
        return () => {
            NotificationManager.default.removeChangeListener(handleStoreChange);
        };
    }, [handleStoreChange]);
    React__namespace.useEffect(() => {
        setNotifications(NotificationManager.default.notifications);
    }, []);
    const handleClose = React__namespace.useCallback((id) => {
        NotificationManager.default.remove(id);
    }, []);
    const items = React__namespace.useMemo(() => notifications.map((notification) => (React__namespace.createElement(Notification.Notification, { key: notification.id, ...notification, onClose: handleClose }))), [handleClose, notifications]);
    return (React__namespace.createElement(Portal.Portal, null,
        React__namespace.createElement("div", { "data-qa": "Notifications", className: cx(className, 'container'), ...restProps },
            React__namespace.createElement(framerMotion.AnimatePresence, null, items))));
});
Notifications.displayName = 'Notifications';

exports.Notifications = Notifications;
//# sourceMappingURL=Notifications.js.map
